import { Link, useSearchParams } from 'react-router-dom';
import RegisterForm from './RegisterForm';
import TeacherJoinPage from './TeacherJoinPage';

export default function RegisterPage() {
  const [searchParams] = useSearchParams();
  const teacherParam = (searchParams.get('teacher') || '').trim();
  const parentToken = (searchParams.get('parent') || '').trim();

  if (teacherParam) {
    return <TeacherJoinPage />;
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2>{parentToken ? 'Регистрация родителя' : 'Регистрация'}</h2>
        <p className="auth-subtitle">
          {parentToken
            ? 'Создайте аккаунт родителя — вы будете привязаны к ученику по ссылке-приглашению'
            : 'Создайте аккаунт для начала обучения'}
        </p>
        {parentToken && (
          <div className="alert alert-info" style={{ marginBottom: '1rem' }}>
            После регистрации откроется короткая анкета родителя.
          </div>
        )}
        <RegisterForm parentToken={parentToken || undefined} />
        <p className="auth-link">
          Уже есть аккаунт?{' '}
          <Link
            to={
              parentToken
                ? `/login?next=${encodeURIComponent(`/parent-invite/${parentToken}`)}`
                : '/login'
            }
          >
            Войти
          </Link>
        </p>
      </div>
    </div>
  );
}
